import React from 'react';
import Clickable from 'src/app/atoms/Clickable/Clickable';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography from 'src/app/atoms/Typography/Typography';

export interface MegaMenuLinkProps {
  label: string;
  href: string;
  icon: JSX.Element;
}

const MegaMenuLink = ({ href, label, icon }: MegaMenuLinkProps): JSX.Element => {
  return (
    <Clickable
      key={label}
      href={href}
    >
      <Stack
        direction='row'
        align='center'
        gap='spacing-lg'
        padding='spacing-lg'
        paddingLg={['spacing-lg', 'spacing-none', 'spacing-lg', 'spacing-none']}
        borderRadius={'radius-md'}
        className='feature-link'
      >
        {icon}
        <Typography
          type='paragraph'
          size='md'
          fontWeight='font-weight-semibold'
          color='text-primary'
        >
          {label}
        </Typography>
      </Stack>
    </Clickable>
  );
};

export default MegaMenuLink;
